export default __webpack_public_path__ + "static/media/separator1-img4.ec96cd2f.png";